const parseEntryAmount = (entry) =>
  parseFloat(entry?.amount ?? entry?.amt ?? entry?.total_amount ?? 0) || 0;

const isJaavakPayType = (entry) => {
  const payType = String(entry?.pay_type ?? entry?.payType ?? "").toUpperCase();
  return payType === "JAAVAK" || payType === "JAVAK";
};

const collectSalePayableEntries = (data = {}) => {
  const sources = [
    data.sale_payable,
    data.salePayable,
    data.payables,
  ];
  for (const source of sources) {
    if (Array.isArray(source) && source.length > 0) {
      return source;
    }
  }
  return [];
};

/**
 * Cash return for invoice print — only from saved cash-out (JAAVAK) entries.
 * Does not infer return from payable_amount or payment excess.
 */
export function getInvoiceCashReturnAmount(data = {}) {
  const salePayables = collectSalePayableEntries(data);
  if (salePayables.length > 0) {
    return salePayables.reduce((sum, entry) => sum + parseEntryAmount(entry), 0);
  }

  const payments = Array.isArray(data.payments) ? data.payments : [];
  return payments
    .filter(isJaavakPayType)
    .reduce((sum, entry) => sum + parseEntryAmount(entry), 0);
}
